import * as React from "react";

/**
 * SSR-safe matchMedia: server and the hydration pass must see the same value
 * as getServerSnapshot (see React useSyncExternalStore). Avoids Radix/useId
 * hydration mismatches when branching between Dialog vs Sheet by viewport.
 */
export function useMediaQuery(query: string) {
  const subscribe = React.useCallback(
    (onStoreChange: () => void) => {
      const mq = window.matchMedia(query);
      mq.addEventListener("change", onStoreChange);
      return () => mq.removeEventListener("change", onStoreChange);
    },
    [query],
  );

  const getSnapshot = React.useCallback(
    () => window.matchMedia(query).matches,
    [query],
  );

  const getServerSnapshot = React.useCallback(() => false, []);

  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
